import { RegexMatch } from "@/data/enums/router";

export default [
  {
    path: "support",
    components: {
      default: {
        name: "ClientSupport",
        template: `<router-view />`
      },
      menu: () => import("@/skeleton/client/loggedIn/menu.vue")
    },
    props: {
      menu: {
        routes: require("./menu").default,
        background: "light"
      }
    },
    meta: {},
    children: [
      {
        path: "",
        name: "clientSupport",
        redirect: "tickets"
      },
      {
        path: "tickets",
        component: {
          name: "ClientSupportTickets",
          template: `<router-view />`
        },
        meta: {
          title: "_.tickets"
        },
        children: [
          {
            path: "",
            name: "clientSupportTickets",
            component: () => import("@/views/client/support/tickets/index.vue")
          },
          {
            path: "add",
            name: "clientSupportAddTicket",
            component: () =>
              import("@/views/client/support/tickets/ticket/index.vue"),
            meta: {
              title: "_.add"
            }
          },
          {
            path: `:ticketId(${RegexMatch.UUID})`,
            name: "clientSupportTicket",
            props: true,
            component: () =>
              import("@/views/client/support/tickets/ticket/details.vue"),
            meta: {
              title: "_.manage_ticket"
            }
          }
        ]
      }
    ]
  }
];
